import { render, staticRenderFns } from "./hotelCenter.vue?vue&type=template&id=104b3154&scoped=true&"
import script from "./hotelCenter.vue?vue&type=script&lang=js&"
export * from "./hotelCenter.vue?vue&type=script&lang=js&"
import style0 from "./hotelCenter.vue?vue&type=style&index=0&id=104b3154&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b3154",
  null
  
)

export default component.exports